import React, { useEffect, useState } from "react";

const Principal = () => {
  const [principal, setPrincipal] = useState({
    name: "",
    message: "",
    image: "",
  });

  useEffect(() => {
    const fetchPrincipal = async () => {
      try {
        const res = await fetch("https://cms.maitretech.com/seedlingschoolbhopal/items/principal?fields=*.*.*");
        const data = await res.json();
        const item = data?.data?.[0];

        if (item) {
          const imageUrl = item?.profile_pic?.data?.full_url?.replace("http://", "https://");
          setPrincipal({
            name: item.name || "",
            message: item.message || "",
            image: imageUrl || "",
          });
        }
      } catch (error) {
        console.error("Failed to fetch principal data:", error);
      }
    };

    fetchPrincipal();
  }, []);

  return (
    <div className="principal">
      <div className="principal-row">
        <div className="principal-col">
          {principal.image && <img src={principal.image} alt={principal.name} />}
          <h4>{principal.name}</h4>
        </div>
        <div className="principal-col">
          <h2>Principal Message</h2>
          <h6>{principal.message}</h6>
        </div>
      </div>
    </div>
  );
};

export default Principal;
